import { render, staticRenderFns } from "./RegisterVerify.vue?vue&type=template&id=54739f8b&"
import script from "./RegisterVerify.vue?vue&type=script&lang=js&"
export * from "./RegisterVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports